export default 'M0 6h24V3H0zm0 7.5h24v-3H0zM24 18H0v3h24z';